package com.bikompanion.data.analytics

import org.w3c.dom.Storage
import com.bikompanion.data.analytics.web.AnalyticsKeyValueStorage

/**
 * Browser storage that never throws. Reading `localStorage` itself can throw when site data is
 * blocked, and a write can fail when storage is full; analytics then runs without persistence
 * rather than breaking the page.
 */
internal class BrowserAnalyticsStorage(
    private val storage: () -> Storage,
) : AnalyticsKeyValueStorage {
    override fun read(key: String): String? = runCatching { storage().getItem(key) }.getOrNull()

    override fun write(
        key: String,
        value: String,
    ) {
        runCatching { storage().setItem(key, value) }
    }
}
